import React from 'react';

const RightArrow = ({ className = '', ...props }) => {
  return (
   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={`text-v3-black-secondary ${className}`} {...props}>
  <path d="M19 5L6 19M6 5L19 19" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round"/>
</svg>
  );
};

export default RightArrow;
